<template>
  <div class="container" @contextmenu.prevent="rightClick" v-if="visible" id="layerStep">
    <vue-draggable-resizable drag-handle=".ant-card" class="wrap dy3dDialog" :w="dragW" :h="dragH" :resizable='false'>
      <a-card 
        class="layerManage-card"
        :title='title'>

        <!-- <img style="width:16px;cursor: pointer;" :src="require('@/assets/images/closeIcon.png')" slot="extra" @click="handleClose"/> -->
        <a-icon slot="extra" type="close" @click="handleClose"/>

        <!-- 搜索框 -->
        <div style="display:flex;justify-content: space-between;align-items: center;">
          <a-input
            v-model="searchVal" 
            placeholder="请输入检索关键词" 
            @keyup.enter.native='searchEnter'
            @change='clearSearchVal'
            :allowClear="true"
          />

            <!-- <img :src="require('@/assets/images/searchIcon.png')" slot="suffix" @click="onSearch"/> -->
            <!-- <span style="color: rgba(0, 201, 129, 1);cursor: pointer;" @click="reload">重置</span> -->
            <!-- <span style="color: rgba(0, 201, 129, 1);cursor: pointer;" @click="reload">刷新</span> -->
            <!-- <a-icon type='reload' @click="reload" style="line-height:34px"/> -->
        </div>

        <div @contextmenu.stop style="height:88%; overflow:auto">
          <a-tree
            class="tree"
            v-model="checkedKeys"
            :tree-data="treeData"
            :expanded-keys="expandedKeys"
            checkable
            show-icon
            @check='onCheck'
            @select='onSelect'
            @expand="onExpand"
            @rightClick="onRightClick"
            @dblclick="onDoubleClick">
            <img slot='group' type='folder' :src="require('@/assets/images/folderIcon.png')"/>
            <span slot='project' class="iconfont icon-project" style="color:#fff; font-size:21px; margin-right:5px; vertical-align:middle"></span>
            <a-icon slot='service' type='global'></a-icon>
            <span slot='data' class="iconfont icon-layers" style="color:#fff; font-size:21px; margin-right:5px; vertical-align:middle"></span>
            <template slot="custom" slot-scope="item">
                <span :id='item.bsm' :class="item.class" :title="item.dataName">
                  {{item.dataName}}                  
                </span>          
                <a-slider v-if="item.openOpacity" v-model="item.opacity" :min="0" :max="1" :step="0.1" @change="changeOpacity(item,value)"/>
                <!-- <a-input-number v-model="item.opacity" :min="0" :max="1" :step="0.1" style="margin-left: 16px" /> -->
            </template>
          </a-tree>
        </div>
      </a-card>
    </vue-draggable-resizable>
    <slot name="addSource"></slot>
  </div>
</template>

<script>
/* eslint-disable */
import dy3dMap from '../js/dy3dMap.js'
const DYMAP = new dy3dMap()
export default {
  name: 'layer-management',
  props: {
    visible:{
      type: Boolean,
      default: true,
      required: true
    }
  },
  data(){
    return {
      dragW: 280,
      dragH: 280,
      title: '图层管理',
      selectedNode:'',
      checkedKeys: [],
      expandedKeys: [],
      treeData: [],
      arcgisLayerId: [],
      location: '', // 区域权限（行政区代码）- 主要是过滤自然资源图层
      xzqdm:'', // 区域权限（行政区代码） - 主要是过滤基础地理图层
      wtdllx:[], // 委托代理类型
      searchVal:'', // 搜索节点的关键词
      inputValue1:10
    }
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    /**
     * 初始化地图之后同时进行树结构的初始化
     * @param {object} map 地图
     * @param {array} data 图层树
     */
    initMap(map, data){
      this.map = map
      this.treeData = data
    },
    /**
     * 搜索框 - 确认搜索
     */
    searchEnter(e){
      if(e.keyCode == 13){
        this.$emit('searchNode',this.searchVal)
      }
    },
    clearSearchVal(e){
      if(e.type == 'click'){
        this.searchVal = ''
        this.$emit('reloadNode')
      }
    },
    onExpand(key){
      this.expandedKeys = key
    },
    onSelect(key, event){
      let checkedNode = event.node.$vnode.data.props.dataRef
      this.selectedNode = checkedNode
      this.$emit('selectedNode', checkedNode,event)
    },
    onRightClick(event){
      this.$emit('rightClick', event)
    },
    onDoubleClick(v, event){
      this.$emit('doubleClick', event)
    },
    onCheck(key, event){
      let checkedNode = event.node.$vnode.data.props.dataRef
      this.checkedKeys = key
      console.log('check',key,event,checkedNode);
      // 先判断勾选的节点是否是服务节点，如果是服务节点的话就直接加载整个服务，如果不是再进行遍历
      // 只有arcgis服务的时候isServiceNode是true/false,geoserver服务的时候都是false
      // this.loadCheckedLayers(checkedNode, event.checked)
      this.$emit('checkNode',key,checkedNode,event)
      // if(checkedNode.isServiceNode){
      //   this.loadedWholeArcService(checkedNode, event.checked)
      // }else{
      //   let isServiceNode = checkedNode.isServiceNode ? checkedNode.isServiceNode : false
      //   this.transferCheckedNode(checkedNode, isServiceNode, event.checked)
      // }
    },
    // 加载勾选的图层的方法
    loadCheckedLayers(checkedNode,checked,map){
      if(checkedNode.isServiceNode){
        this.loadedWholeArcService(checkedNode, checked, map)
      }else{
        let isServiceNode = checkedNode.isServiceNode ? checkedNode.isServiceNode : false
        this.transferCheckedNode(checkedNode, isServiceNode, checked, map)
      }
    },
    // 遍历选中的节点
    transferCheckedNode(node, isServiceNode, isChecked, map){
      if(node.isServiceNode){
        // 会存在某个大文件夹下有包含服务节点的情况
        this.loadedWholeArcService(node, isChecked, map)
      }else if(!node.isServiceNode && node.children && node.children.length !== 0){
        // 如果不是服务节点且有children的话依次进行遍历
        node.children.forEach(child=>{
          this.transferCheckedNode(child, isServiceNode, isChecked, map)
        })        
      }else{
        // 透明度滑块
        node.openOpacity = node.opacity ? true : false
        // 判断节点需要用什么类型的加载方式（如arcgis or geoserver）
        // 有可能会出现服务一样但是加载方式不一样（如水体，是geoserver但与矢量切片的加载方式不同）
        if(node.loadType === 'ArcGIS Server Rest' && !isServiceNode){
          let index = this.arcgisLayerId.findIndex(item=>item == node.layerId)
          if(isChecked){
            // 选中且layerId不存在的情况就要记录
            if(index == -1){
              this.arcgisLayerId.push(node.layerId)
            }            
          }else{
            // 未选中且layerId存在的情况就要剔除
            if(index > -1){
              this.arcgisLayerId.splice(index,1)
            }            
          }
          // 如果是arcgis服务，又得回头遍历到它的服务节点，并且记下当前需要渲染的layerId
          this.treeData.forEach(treedata=>{
            if(!treedata.loadType){
              treedata.children.forEach(serviceData=>{
                if (serviceData.loadType === 'ArcGIS Server Rest'){
                  this.transferArcgisFindService(treedata, node.serviceBsm, isChecked, map);
                }
              })
            }
          })              
        } else if(node.loadType === 'TMS'){
          if(node.url){
            this.renderMVTLaery(node, isChecked, map)
          }
        } else if (node.loadType === 'PBF') {
          if (node.url) {
            this.renderMVTLaery(node, isChecked, map);
          }
        } else if (node.loadType === 'GeoJson'){
          if(node.url){
            this.renderGeoJsonLayer(node,isChecked, map)
          }
        } else if (node.loadType === '3D Tile'){
          if(node.url){
            this.render3dtilesLayer(node,isChecked,map)
          }
        } else if(node.loadType === 'ArcGIS Server Tile'){
          if (node.url) {
            this.renderArcGISTileLayer(node, isChecked, map);
          }
        } else if(node.loadType === 'OGC WMS'){
          if (node.url) {
            this.renderWMSLayer(node, isChecked, map);
          }
        } else if (node.loadType === 'WMTS') {
          if (node.url) {
            this.renderWMTSLayer(node, isChecked, map);
          }
        } else if(node.loadType === 'XYZ'){
          if (node.url) {
            this.renderXYZLayer(node, isChecked, map);
          }
        }        
      }
    },
    // 遍历arcgis找到它的服务节点
    transferArcgisFindService(node, serviceBsm,isChecked, map){
      let findService = node.length ? node.find(service=>service.key === serviceBsm) : (node.key === serviceBsm ? node : null)
      if (findService) {
        // 找到服务节点之后就去加载服务
        this.renderArcgisLayer(findService, this.arcgisLayerId, isChecked, map);
      }else{
        // 否则就继续遍历
        if(node.children){
          node.children.forEach(item=>{
            this.transferArcgisFindService(item, serviceBsm, isChecked, map);
          })
        } 
      }
    },
    // 遍历arcgis服务下的子节点塞入layerId
    transerferGetLayerID(node, idArr){
      if(node.children && node.children.length !== 0){
        node.children.forEach(child=>{
          this.transerferGetLayerID(child, idArr)
        })          
      }else{
        idArr.push(node.layerId)
      }
    },
    // 直接加载整个服务
    loadedWholeArcService(node, isChecked, map){
      let arcgisLayerId = []
        // 直接加载arcgis服务的节点，记录children底下的所有layerID
        if(isChecked){
          this.transerferGetLayerID(node, arcgisLayerId)
        }else{
          arcgisLayerId = []
        }
        this.arcgisLayerId = arcgisLayerId
        this.renderArcgisLayer(node,arcgisLayerId,isChecked, map)
    },
    // 渲染arcgis服务
    renderArcgisLayer(node, idArr,isChecked, map){
      let currentMap = map ? map: this.map
      // 将arcgis服务底下的图层全部都压入到this.map.allLayers中（这段代码暂时先放在这里，看看之后放哪里比较好） - 用于识别
      currentMap.allLayers = []
      this.treeToList(node.children,currentMap.allLayers)

      // arcgis中所需的必须参数
      let arcgisObj = {
        id:node.key,
        url:node.url,
        name:node.title,
        layersArr:idArr,
        layers:idArr.toString(),
        show:true,
        flyTo:true
      }
      // 需要判断map中是否已经存在arcgis服务，如果存在就不需要重复加载
      let loadedService = currentMap.getLayerById(arcgisObj.id)
      if(!loadedService){
        DYMAP.loadLayers(arcgisObj,node.loadType, currentMap)
      }else{
        // 复选框勾选状态呈现的方式不一样
        if(isChecked){
          loadedService.setOptions({ layersArr:arcgisObj.layersArr, layers: arcgisObj.layersArr.toString(), show: true})
        }else{
          let show = loadedService.options.layersArr.length !== 0 ? true : false
          loadedService.setOptions({ layersArr: arcgisObj.layersArr,layers: arcgisObj.layersArr.toString(), show: show})
        }
        
      }      
    },
    // 将树转成列表 （主要用于arcgis服务把服务底下的图层都压入到map.allLayers当中方便图层的识别操作）
    treeToList(tree,result = []){
      tree.forEach(node=>{
        result.push(node)
        node.childLayers && this.treeToList(node.childLayers,result)
      })
      return result
    },
    // 渲染geoserver矢量切片
    renderMVTLaery(node, isChecked, map){
      var styleJson
      var labelStyleJson
      let currentMap = map ? map: this.map
      var style = node.style.trim() !== '' && JSON.parse(node.style)
      // 如果node.style存在，那么转换成对象形式获取到里面的样式配置;优先获取styleJSON里面的样式，如果styleJSON中没有配置样式，那么就使用style的样式
      if(style){
        console.log('样式',style);
        styleJson = JSON.parse(node.style).styleJSON ? JSON.parse(JSON.parse(node.style).styleJSON) : JSON.parse(node.style).style
        labelStyleJson = style.labelStyle ? style.labelStyle : null
      }

      let mvtObj = {
        id: node.key,
        name: node.title,
        url: node.url,
        queryUrl: node.queryUrl,
        style: styleJson ? styleJson : null,
        labelStyle: labelStyleJson,
        attributes:node.attributes,
        labelShow:node.labelShow,
        filter: node.filter
        // location: this.location,
        // xzqdm: this.xzqdm,
        // // wtdl: this.wtdllx
        // wtdl: node.wtdllx
      }
      console.log('mvtObj',mvtObj);
      let loadedService = currentMap.getLayerById(mvtObj.id)
      
      if(!loadedService){
        console.log('initinit');
        DYMAP.loadLayers(mvtObj, node.loadType, currentMap)
      }else{
        if(isChecked) {
          loadedService.show = true
          // currentMap.removeLayer(loadedService);
        }else {
          loadedService.show = false
        }
      }
      console.log('geoserver', loadedService, currentMap.getLayers());
    },
    // 渲染geojson
    renderGeoJsonLayer(node, isChecked, map){
      console.log('geojson',node)
      let currentMap = map ? map: this.map
      let style = node.style ? JSON.parse(node.style) : null;
      // console.log(styleJson);
      let jsonObj = {
        id: node.key,
        name: node.title,
        url: node.url,
        queryUrl: node.queryUrl,
        style: style,
        attributes: node.attributes,
        loadType: 'GeoJSON',
        dataType: style && style.styleDataType ? style.styleDataType : '2DModel',
        styleSpecificType: style && style.styleSpecificType ? style.styleSpecificType : null,
        // 如果是水体的话，isWater就是true，如果不是水体的话这个就不用写(这边还要做优化，暂时先这样)
        isWater: node.title.includes('水体') ? true : false,
        heightAttr:node.heightAttr, // 白膜的高度属性
        colorAttr:node.colorAttr,// 白膜的自定义颜色属性
        highlight:node.highlight // 高亮的属性（只对白膜有效）
      };
      console.log('水体Obj',jsonObj);
      if(jsonObj.isWater || jsonObj.styleSpecificType == 'waterPolygon'){
        let loadedPrimitive = currentMap.scene.primitives._primitives
        console.log('initinit',loadedPrimitive);
        let isCurrentPrimitive
        loadedPrimitive.forEach(primi=>{
          if(primi.id == jsonObj.id){
            isCurrentPrimitive = primi
          }
        })      
        if (!isCurrentPrimitive) {
          console.log('isCurrentPrimitive',isCurrentPrimitive)     
          DYMAP.loadLayers(jsonObj, jsonObj.loadType, currentMap)
        } else {
          var index = loadedPrimitive.indexOf(isCurrentPrimitive)
          if (isChecked) {
            // 水体模型的移除跟其它图层的移除方法不太一样
            console.log('currentPrimitives',currentMap.scene.primitives.get(index))
            // currentMap.scene.primitives.remove(currentMap.scene.primitives.get(index));
            currentMap.scene.primitives.get(index).show = true
          }else{
            currentMap.scene.primitives.get(index).show = false
          }
        }
      }else{
        let loadedService = currentMap.getLayerById(jsonObj.id);
        if (!loadedService) {
          console.log('initinit',jsonObj);
          DYMAP.loadLayers(jsonObj, jsonObj.loadType, currentMap);
        } else {
          if(isChecked) {
            loadedService.show = true
            // currentMap.removeLayer(loadedService);
          }else {
            loadedService.show = false
          }
        }
      }
    },
    // 渲染3dtiles
    render3dtilesLayer(node, isChecked, map){
      console.log('3dtiles', node);
      let currentMap = map ? map: this.map
      var style = node.style ? JSON.parse(node.style) : null;
      console.log('tilesstyle',style);
      var tilesObj = {
        id: node.key,
        name: node.title,
        url: node.url,
        queryUrl: node.queryUrl,
        style: style,
        attributes: node.attributes,
        loadType: '3dTiles',
        isNonOblique: style && style.isNonOblique
      };
      var loadedService = currentMap.getLayerById(tilesObj.id);
      if (!loadedService) {
        console.log('initinit', tilesObj);
        DYMAP.loadLayers(tilesObj, tilesObj.loadType, currentMap);
      } else {
        if(isChecked) {
          loadedService.show = true
          // currentMap.removeLayer(loadedService);
        }else {
          loadedService.show = false
        }
      }
    },
    // 渲染arcgis影像
    renderArcGISTileLayer(node, isChecked,map){
      console.log('tiles', node);
      let currentMap = map ? map: this.map
      var tilesObj = {
        id: node.key,
        name: node.title,
        url: node.url,
        loadType: 'ArcGIS Server Tile',
      };
      var loadedService = currentMap.getLayerById(tilesObj.id);
      if (!loadedService) {
        console.log('initinit', tilesObj);
        DYMAP.loadLayers(tilesObj, tilesObj.loadType, currentMap);
      } else {
        if(isChecked) {
          loadedService.show = true
          // currentMap.removeLayer(loadedService);
        }else {
          loadedService.show = false
        }
      }
    },
    // 加载WMS图层
    renderWMSLayer(node,isChecked,map){
      console.log('wms', node);
      let currentMap = map ? map: this.map
      var wmsObj = {
        id: node.key,
        name: node.title,
        layers: node.alias,
        attributes: node.attributes,
        url: node.url,
        loadType: 'WMS'
      };
      var loadedService = currentMap.getLayerById(wmsObj.id);
      if (!loadedService) {
        console.log('initinit', wmsObj);
        DYMAP.loadLayers(wmsObj, wmsObj.loadType, currentMap);
      } else {
        if(isChecked) {
          loadedService.show = true
          // currentMap.removeLayer(loadedService);
        }else {
          loadedService.show = false
        }
      }
    },
    // 加载WMTS图层
    renderWMTSLayer(node, isChecked, map) {
      console.log('wmts', node);
      let currentMap = map ? map: this.map
      var wmtsObj = {
        id: node.key,
        name: node.title,
        attributes: node.attributes,
        url: node.url,
        layer:node.alias,
        flyTo:false,
        loadType: 'WMTS'
      };
      var loadedService = currentMap.getLayerById(wmtsObj.id);
      if (!loadedService) {
        console.log('initinit', wmtsObj);
        DYMAP.loadLayers(wmtsObj, wmtsObj.loadType, currentMap);
      } else {
        if(isChecked) {
          loadedService.show = true
          // currentMap.removeLayer(loadedService);
        }else {
          loadedService.show = false
        }
      }
    },
    // 加载XYZ图层
    renderXYZLayer(node,isChecked, map){
      console.log('xyz', node);
      let currentMap = map ? map: this.map
      var xyzObj = {
        id: node.key,
        name: node.title,
        attributes: node.attributes,
        url: node.url,
        loadType: 'XYZ'
      };
      var loadedService = currentMap.getLayerById(xyzObj.id);
      if (!loadedService) {
        console.log('initinit', xyzObj);
        DYMAP.loadLayers(xyzObj, xyzObj.loadType, currentMap);
      } else {
        if(isChecked) {
          loadedService.show = true
          // currentMap.removeLayer(loadedService);
        }else {
          loadedService.show = false
        }
      }
    },
    changeOpacity(node,value){
      console.log('透明度改变',node,value);
      this.transferChangeOpacity(this.treeData, node.opacity, node.bsm)
      this.treeData = [...this.treeData]
    },
    transferChangeOpacity(node, opacity, key){
      node.forEach(item => {
        if(item.children){
          this.transferChangeOpacity(item.children, opacity, key)
        }else{
          if(item.bsm === key){
            item.opacity = opacity
            let currentLayer = this.map.getLayerById(item.bsm)
            if(currentLayer){
              currentLayer.opacity = opacity
            }
            // currentLayer && ()
          }
        }
      })
    },
    handleClose(){
      this.$emit('closeLayermanagement')
    }
  },
}
</script>

<style  lang="less" scoped>
.container {
  position: absolute;
  top: 0%;
  left: 0%;
  width: 18%;
  height: calc(100% - 34px);
  background: transparent !important;
  .wrap {
    z-index: 1000 !important;
    width: 100% !important;
    height: 100% !important;
  }
  .layerManage-card {
    width: 100%;
    height: 100%;
    cursor: move;
  }
  /deep/.ant-card-head-title {
    color: #fff;
    padding: 0;
  }
  /deep/ .ant-card {
    backdrop-filter: blur(15px);
    .ant-input{
      background: rgba(255, 255, 255, 0.10) !important;
      border: 1px solid rgba(255, 255, 255, 0.50);
      &::placeholder {
        color: rgba(255, 255, 255, 0.30);
        font-size: 12px;
      }
    }
  }
  /deep/ .ant-card-head {
    padding: 0 10px;
    width: 96%;
    min-height: 0px;
    height: 5%;
    display: flex;
    margin: auto;
    border-bottom: 1px solid rgba(255, 255, 255, 0.20);
    &:hover {
      cursor:move;
    }
  }

  /deep/ .ant-card .ant-card-body > div {
    &:nth-child(1) {
      height: 5%;
      width: 80%;
      /deep/ .ant-input-affix-wrapper {
        position: relative;
        /deep/ .ant-input-suffix {
          position: absolute;
          left: 80%;
        }
      }
    }
    &:nth-child(2) {
      height: 95% !important;
      background: none;
      & > ul {
        height: 100%;
      }
    }
  }
  
  /deep/ .ant-card-body {
    width: 100%;
    padding: 11px 0 0 11px;
    height: 95%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  /deep/ .ant-card-head-wrapper {
    width:100%;
    background: transparent !important;
  }
  // 隐藏拖拽弹框的小圆圈，并调整位置
  /deep/ .handle {
    opacity: 0;
  }
  /deep/ .handle-tl {
    top: -5px;
    left: -5px;
  }
  /deep/ .handle-tr {
    top: -5px;
    right: -5px;
  }
  /deep/ .handle-bl {
    bottom: -5px;
    left: -5px;
  }
  /deep/ .handle-br {
    bottom: -5px;
    right: -5px;
  }
}
</style>